import { render, staticRenderFns } from "./SystemAccessHistory.vue?vue&type=template&id=917960f4&scoped=true"
import script from "./SystemAccessHistory.vue?vue&type=script&lang=js"
export * from "./SystemAccessHistory.vue?vue&type=script&lang=js"
import style0 from "./SystemAccessHistory.vue?vue&type=style&index=0&id=917960f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "917960f4",
  null
  
)

export default component.exports